export default __webpack_public_path__ + "static/media/DukeUniversityHospital.05823599.svg";